import React, { useState } from 'react';
import GenericTable from 'shared/components/common/table/table';
import styles from '../sale_order/style.module.scss';
import { ProjectNameIcon, StatusCheckIcon, EditIcon } from 'assets';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import Heading from 'shared/components/common/heading/Heading';
import EditQuantityModal from 'shared/modal/sale_order_supplier/EditSoQuantityModal';

const ReturnItemTable = ({ items, handleUpdateQuantity, handleToggleSelect }) => {
    const { theme: { theme } } = useSelector((state) => state.root);

    const [openEditModal, setOpenEditModal] = useState(false);
    const [selectedItemForEdit, setSelectedItemForEdit] = useState(null);

    const columns = React.useMemo(
        () => [
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        Select
                    </div>
                ),
                accessor: 'isSelected',
                Cell: ({ row }) => (
                    <input
                        type="checkbox"
                        checked={row.original.isSelected}
                        onChange={() => handleToggleSelect(row.index)}
                        style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                    />
                )
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        SKU
                    </div>
                ),
                accessor: 'sku',
                Cell: ({ row }) => <div>{row.original?.sku}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        Product Model
                    </div>
                ),
                accessor: 'product',
                Cell: ({ row }) => <div>{row.original?.product?.name}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        Sold Qty
                    </div>
                ),
                accessor: 'maxReturnQty',
                Cell: ({ row }) => <div>{row.original.maxReturnQty}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        Return Qty
                    </div>
                ),
                accessor: 'returnQty',
                Cell: ({ row }) => (
                    <div className="d-flex align-items-center">
                        <span className="me-2">{row.original.returnQty}</span>
                        {row.original.isSelected && (
                            <EditIcon
                                className="pointer"
                                style={{ width: '16px' }}
                                onClick={() => {
                                    setSelectedItemForEdit({
                                        index: row.index,
                                        quantity: row.original.returnQty,
                                        productName: row.original?.product?.name,
                                        maxQuantity: row.original?.maxReturnQty
                                    });
                                    setOpenEditModal(true);
                                }}
                            />
                        )}
                    </div>
                )
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        Price
                    </div>
                ),
                accessor: 'price',
                Cell: ({ row }) => <div>Rs {Number(row.original.price).toFixed(2)}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        Subtotal
                    </div>
                ),
                accessor: 'subtotal',
                Cell: ({ row }) => <div>Rs {(Number(row.original.price) * Number(row.original.returnQty)).toFixed(2)}</div>
            }
        ],
        [theme, items, handleToggleSelect]
    );

    return (
        <div className={'text-start mt-3'}>
            <div className={styles.Header}>
                <Heading heading={'Items in Sale Order'} headingStyle={styles.Heading} />
                <p className="text-muted small">Select items and set quantity to return</p>
            </div>

            <GenericTable columns={columns} data={items || []} TableWrapperStyle={classNames(styles.Table)} />

            <div className={styles.TableFooter}>
                <div className={styles.SubtotalRow}>
                    <strong>Total Return Value:</strong> Rs {items?.reduce((sum, item) => sum + (item.isSelected ? (item.price * item.returnQty) : 0), 0).toFixed(2)}
                </div>
            </div>

            {openEditModal && (
                <EditQuantityModal
                    show={openEditModal}
                    handleClose={() => setOpenEditModal(false)}
                    selectedItem={selectedItemForEdit}
                    onUpdate={handleUpdateQuantity}
                />
            )}
        </div>
    );
};

export default ReturnItemTable;
